export default {"src":"/_next/static/media/geckoterminal.4d54efad.svg","height":1200,"width":1200,"blurWidth":0,"blurHeight":0};